<template>
  <wrap ref="wrap" class="dialog" title="今日已结">
    <ul ref="list" class="table-list">
      <li class="qc-16" v-if="step===2">
          <CTable class="table-w"
                  :head="head"
                  :body="two_list"
          >
            <template slot-scope="{data}" slot="result">
              <span :style="{'color':data.result<0?'green' : data.result > 0 ? 'red' : ''}">{{data.result}}</span>
            </template>
            <template slot-scope="{data}" slot="lottery_name_link">
              <a @click="toThree(data)" href="javascript:;">{{data.lottery_name}}</a>
            </template>
          </CTable>
        </li>
        <li class="qc-16" v-if="step===3">
          <CTable class="table-w"
                  :head="head"
                  :body="three_list"
          >
            <template slot-scope="{data}" slot="result">
              <span :style="{'color':data.result<0?'green' : data.result > 0 ? 'red' : ''}">{{data.result}}</span>
            </template>
            <template slot="period" slot-scope="{data}">
              <a href="javascript:;" @click="toFour(data)">{{data.period}}</a>
            </template>
          </CTable>
        </li>

        <li class="qc-16" v-if="step===4">
          <CTable class="table-w"
                  :head="head"
                  :body="four_list"
          >
            <template slot-scope="{data}" slot="win">
              <span :style="{'color':data.win<0?'green' : data.win > 0 ? 'red' : ''}">{{data.win}}</span>
            </template>
            <template slot="class2_class3" slot-scope="{data}">
             <span>{{data.class2}}</span>
             <Popover placement="right" trigger="click" v-if="data.class4!=null">
                  <Table border :data="data.class4" style="max-height:400px;overflow:auto">
                    <TableColumn width="150" property="class3" label="号码">
                      <template slot-scope="scope">
                        <span :class="[scope.row.is_win==1 ? 'red' : '']">{{scope.row.class3}}</span>
                      </template>
                    </TableColumn>
                    <TableColumn width="80" property="odds" label="中二赔率" v-if="data.class2=='三中二' || data.class2=='三中二X'">
                      <template slot-scope="scope">
                        <span :class="[scope.row.is_win==1&&scope.row.odds_option==0 ? 'red' : '']">{{scope.row.odds}}</span>
                      </template>
                    </TableColumn>
                    <TableColumn width="80" property="odds" label="中特赔率" v-else-if="data.class2=='二中特' || data.class2=='二中特X'">
                      <template slot-scope="scope">
                        <span :class="[scope.row.is_win==1&&scope.row.odds_option==0 ? 'red' : '']">{{scope.row.odds}}</span>
                      </template>
                    </TableColumn>
                    <TableColumn width="80" property="odds" label="赔率" v-else>
                      <template slot-scope="scope">
                        <span :class="[scope.row.is_win==1 ? 'red' : '']">{{scope.row.odds}}</span>
                      </template>
                    </TableColumn>
                    <TableColumn width="80" property="odds" label="中三赔率" v-if="data.class2=='三中二' || data.class2=='三中二X'">
                      <template slot-scope="scope">
                        <span :class="[scope.row.is_win==1&&scope.row.odds_option==1 ? 'red' : '']">{{scope.row.odds2}}</span>
                      </template>
                    </TableColumn>
                    <TableColumn width="80" property="odds" label="中二赔率" v-else-if="data.class2=='二中特' || data.class2=='二中特X'">
                      <template slot-scope="scope">
                        <span :class="[scope.row.is_win==1&&scope.row.odds_option==1 ? 'red' : '']">{{scope.row.odds2}}</span>
                      </template>
                    </TableColumn>
                  </Table>
                  <p style="text-align: right;margin-top: 5px;">共 <span class="red">{{data.zs}}</span> 注，每注 <span class="red">{{data.money2}}</span> 元<span v-if="data.status!=1">，中 <span class="red">{{data.win_zs}}</span> 注</span></p>
                  <span slot="reference"><span class="hasClass4">{{data.class3}}</span></span>
                </Popover>
                <span class="blue" v-else>{{data.class3}}</span>
            </template>
            <template slot-scope="{data}" slot="odds_odds2">
                <span v-if="data.class2=='三中二'||data.class2=='二中特' || data.class2=='三中二X'||data.class2=='二中特X'">{{data.odds}}/{{data.odds2}}</span>
                <span v-else>{{data.odds}}</span>
              </template>
            <template slot-scope="{data}" slot="status">
              <span class="green" v-if="data.status==1 || data.status==2">有效</span>
              <span class="red" v-else-if="data.status==3">取消
                <p v-if="data.cancel_time!=''">{{data.cancel_time}}</p>
              </span>
            </template>
          </CTable>
        </li>
    </ul>
  </wrap>
</template>

<script>
  import {history, history2, history3,history4} from '../../service/report';
  import Wrap from './wrap';
  import mixin from './mixin';
  import CTable from './table';
  import {Popover,Table,TableColumn,} from "element-ui";

export default {
    name: "QC15",
    components: {Wrap, CTable,Popover,Table,TableColumn},
    computed: {
      head() {
        if (this.step === 2) return [
         // {label: '彩票类型', value: 'lottery_name_link'},
          {label: '注数', value: 'count'},
          {label: '下注金额', value: 'bet_money'},
          {label: '有效金额', value: 'bet_money_real'},
          {label: '退水', value: 'commission'},
          {label: '输赢', value: 'result'}
        ];
        if (this.step === 3) return [
          {label: '期号', value: 'period'},
          //{label: '彩票类型', value: 'lottery_name'},
          {label: '注数', value: 'count'},
          {label: '下注金额', value: 'bet_money'},
          {label: '有效金额', value: 'bet_money_real'},
          {label: '退水', value: 'commission'},
          {label: '输赢', value: 'result'}
          // 详情
        ];
        if(this.step === 4) return [
          {label: '订单号', value: 'order_id'},
          {label: '时间', value: 'date_time'},
         // {label: '彩种名称', value: 'lottery_name'},
          {label: '期号', value: 'period'},
          {label: '类型', value: 'class2_class3'},
          {label: '赔率', value: 'odds_odds2'},
          {label: '投注金额', value: 'money'},
          {label: '退水', value: 'rebate'},
          {label: '输赢', value: 'win'},
          {label: '状态', value: 'status'}
        ];
      }
    },
    data() {
      return {
        step: 2,
        // 彩种
        lottery_type: '',
        // 日期
        date: '',
        two_list: [],
        three_list: [],
        four_list: []
      };
    },
    methods: {
      async toFour(item){
        this.step++;
        this.loading = true;
        const info = await history4({
          period: item.period,
          lottery_type: this.lottery_type
        });
        this.loading = false;
        if (info.result === 'ok') {
          this.four_list = (info.data.data || []);
        }
      },

      async toThree(item) {
        this.step++;
        this.lottery_type = item.lottery_type;
        this.loading = true;
        const info = await history3({
          date: this.date,
          lottery_type: this.lottery_type
        });
        this.loading = false;
        if (info.result === 'ok') {
          this.three_list = (info.data || []).map(e => {
            e.lottery_name = item.lottery_name;
            return e;
          });
        }
      },
      sum(list, key) {
        const f = n => Math.round(n * 10000) / 10000;
        return list.reduce((p, n) => f(p + n[key]), 0);
      },
      async toTwo({date}) {
        this.step++;
        this.date = date;
        this.loading = true;
        const info = await history2(date);
        this.loading = false;
        if (info.result === 'ok') {
          this.two_list = info.data;
        }
      },
      async loadInfo() {
        let url = this.$refs.list.baseURI;
        if (url.indexOf('lottery_type=19') > -1)
        {
          this.lottery_type = 19;
        }else if (url.indexOf('lottery_type=18') > -1)
        {
          this.lottery_type = 18;
        }else if (url.indexOf('lottery_type=17') > -1)
        {
          this.lottery_type = 17;
        }else if (url.indexOf('lottery_type=16') > -1)
        {
          this.lottery_type = 16;
        }else if (url.indexOf('lottery_type=15') > -1)
        {
          this.lottery_type = 15;
        }
        this.toThree({lottery_type: this.lottery_type})
      },
      show() {
        //打开今日已结则重新初始化step，否则会一直+，导致页面空白
        this.step=2;
        this.$refs.wrap.show();
      },
      hide() {
        this.$refs.wrap.hide();
      },

      /**
       * 合计
       * @param arr
       * @returns {string}
       */
      reduceArr(arr) {
        const plus = arr.reduce((prev, cur) => {
          return parseFloat(prev) + parseFloat(cur);
        }, 0);
        return plus.toString() === 'NaN' ? '—' : plus;
      },
      calOffsetLeft() {
        this.list = this.$refs.list;
        const children = this.list.children;
        return Array.from(children, (dom) => dom.offsetLeft);
      }
    },
    mounted() {
    }
  }
</script>
<style>
.el-table td,.el-table th{padding:unset !important;}
.el-table .cell{line-height:unset !important;}
.el-table .cell span{
  line-height: 10px;
  font-size: 10px;
}
  .hasClass4 {
    border-bottom: 1px dashed #1e90ff;
    color: #1e90ff;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
  }
</style>
<style lang="stylus" scoped>
  .block_tip {
    font-size: 14px;
  }

  .top_btn {
    font-size: 14px;
    text-align: right;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC15.vue